import Axios from 'axios'
import {configure} from "axios-hooks";
import TokenService from "../services/token.service";
import {useCallback, useState} from "react";
let tokenTimer;

const setTokenTimestamp = () => {
    const TOKEN_TTL = Number(localStorage.getItem("token_ttl")) || 0
    // const expiry = localStorage.getItem("expiry");
    // if (Date.now() > expiry) { // nie wazny
    // 	TokenService.clearLocalStorage();
    // 	window.location.replace("/login");
    // 	return
    // }
    localStorage.setItem("expiry", Date.now() + TOKEN_TTL)

    if (typeof tokenTimer === "number") {
        clearTimeout(tokenTimer)
    }

    tokenTimer = setTimeout(() => {
        TokenService.clearLocalStorage();
        window.location.replace("/login");
    }, TOKEN_TTL)
};

const createAxiosInstance = (contentType = "application/json") => {
    const axiosInstance = Axios.create({
        baseURL: process.env.REACT_APP_API_HOST,
        headers: {
            "Content-Type": contentType,
        },
        timeout: 30 * 1000,
    });

    axiosInstance.interceptors.request.use(requestConfig => {
        if (requestConfig?.headers) {
            const authToken = TokenService.getLocalAccessToken();
            if (authToken) {
                setTokenTimestamp();
                requestConfig.headers["Authorization"] = `Token ${authToken}`;
            }
        }
        return requestConfig;
    });

    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            const { response, message, code } = error;

            if (code === "ERR_NETWORK") {
                window.location.replace('/network-error');
            }
            // else if (response?.status === 400) {
            //     console.log('Status:', error.response?.status);
            //     console.log('Dane błędu:', error.response?.data);
            // }
            else if (response?.status === 401 ||
                response?.data?.errors === "authenticationCredentialsWereNotProvided." ||
                response?.data?.errors === "Invalid token.") {
                TokenService.clearLocalStorage();
                window.location.replace("/login");
            } else if (response?.status === 404) {
                console.log('Status:', error.response?.status);
                console.log('Dane błędu:', error.response?.data);
            } else {
                window.location.replace('/network-error');
            }
            return Promise.reject(error);
        }
    );
    return axiosInstance;
};

const axiosInstance = createAxiosInstance();

// Skonfiguruj axios-hooks
configure({ axios: axiosInstance, cache: false });


// function useEndpoint() {
//     const [{ data, loading, error }, execute] = useAxios(
//         {},
//         { manual: true }
//     );
//
//     const makeRequest = async (url, payload = null, method = "GET") => {
            // execute - funkcja do ręcznego wykonania zapytania HTTP, Promise z response,
            // Automatycznie aktualizuje state (data, loading, error)
//         const res = await execute({
//             url,
//             method,
//             data: payload,
//         })
//         return res.data
//     };
//     return [{ data, loading, error }, makeRequest]
// }

function useEndpoint() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const makeRequest = useCallback(async (url, method = "GET", data = null) => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance({
                url,
                method,
                data
            });
            return response.data;
        } catch (err) {
            setError(err);
            console.error('API Request Error:', err);
            throw err; // Rzuć błąd dalej, żeby catch w komponencie mógł go obsłużyć
        } finally {
            setLoading(false);
        }
    }, []);

    const reset = useCallback(() => {
        setLoading(false);
        setError(null);
    }, []);

    return { makeRequest, loading, error, reset };
}

export default useEndpoint;


